import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ParseHTML from "../../global/components/ParseHTML";
import { IReportsMessageProps } from '../types/interfaces/IReportsMessageProps';

//This component is responsible for displaying the reports message.
export default function ReportsMessage({ message }: IReportsMessageProps) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(message)}</Typography>
        </Box>
    );
}
